import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BrandLogo, NavbarLayout } from '.';
import { useMainDrawer } from '../../component/drawer/MainDrawerContext';
import { BreadcrumbLink } from './NavbarLayout';
import { TenantHeaderInfo } from './TenantHeaderInfo';
import { UserMenu } from './UserMenu';

interface Props {
  topPanel?: React.ReactNode;
  title?: string;
  breadcrumbs?: readonly BreadcrumbLink[];
}

export const AuthorizedLayout: React.FC<React.PropsWithChildren<Props>> = ({ topPanel, title, breadcrumbs, children }) => {
  const { t } = useTranslation('navigationModule');
  const { open, handleOpen: handleOpenDrawer } = useMainDrawer();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'));
  // Below lg there is no room for the tenant line next to logo and menu, so the header stays logo + short title.
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <NavbarLayout
      logo={
        isSmallScreen ? (
          <BrandLogo />
        ) : isMobile ? (
          <BrandLogo subtitle={<TenantHeaderInfo />} />
        ) : (
          <Stack>
            <Typography sx={{ verticalAlign: 'middle' }} component="span" variant="h2">
              {t('titleFull')}
            </Typography>
            <TenantHeaderInfo />
          </Stack>
        )
      }
      menu={<UserMenu />}
      title={title}
      breadcrumbs={breadcrumbs}
      topPanel={topPanel}
      onOpenDrawer={handleOpenDrawer}
      open={open}
    >
      {children}
    </NavbarLayout>
  );
};
